import { render } from "./ProductActionButton.vue?vue&type=template&id=98b24488"
import script from "./ProductActionButton.vue?vue&type=script&lang=js"
export * from "./ProductActionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__